import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.topBar', {
      container: {
        bg: 'white',
        px: '120px',
        position: 'sticky',
        top: '0',
        boxShadow: 'level1',
        zIndex: 10,
      },
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mx: 'auto',
        height: 72,
      },
      right: {
        wrapper: {
          display: 'flex',
          alignItems: 'center',
        },
        avatar: {
          ml: '5x',
          fontSize: '14px',
          color: 'body',
          display: 'flex',
          alignItems: 'center',
        },
        avatarText: {
          maxWidth: 84,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
      left: {
        wrapper: {
          display: 'flex',
          alignItems: 'center',
        },
        title: {
          mr: '6x',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 'bold',
          fontSize: 20,
          color: 'body',
        },
        textBox: {
          maxWidth: 180,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
    }),
  ]
}
